import React from 'react';
import { SvgIcon } from '@material-ui/core';

const MusicIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/music.svg" alt="" />
  );
};

export default MusicIcon;
